module.exports = __webpack_public_path__ + "img/AFMS_DREAR_CLOSE.ee2ca225.png";